import React from 'react'
import Navbar from '../inc/Navbar'
import Slider from '../inc/Slider'
import about from "../images/front o.jpg";
import ReactPlayer from "react-player";
import "./Home.css";
import Gallery from './Gallery';
import iticourse from "../images/iti-course.jpg";
import hotelmanagement from "../images/Hotel_management.jpg";
import paramedical from "../images/paramedical.jpg";
import Notice from './Notice';
import LatestNews from './LatestNews';
import ScrollToTop from "react-scroll-to-top";
import Itiphoto from './Itiphoto';
import ParamedicalPhoto from './ParamedicalPhoto';

function Home() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br/>
      <div className="album py-1">
      <div className="container">
        <h4>Maa Tara Foundation</h4>
        </div>
        </div>

      <Slider />



      <div className='backgroundmarquee'>
        <marquee>
          <div className="album py-0">
            <div className="container mt-2">
              <h4 style={{ color: "white" }}>Welcome to Maa Tara Foundation |  Best ITI, Hotel Management & Paramedical College in Murshidabad</h4>
            </div>

          </div>

        </marquee>
      </div>
      <br />
      <div className="album py-0">
        <div className="container">
          <div className='colortext'>
            <h2 className='mb-3'><b>Maa Tara Foundation</b></h2>
          </div>
        </div>
      </div>
      <div className="album py-0">
        <div className="container">
          <div className="row ">
            <div className="col-md-6">
              <div className="card-body">
                <h5 className="card-title mb-2 justifytext">At Maa Tara Private Industrial Training Institute, our primary objective is to provide high-quality vocational education and training to aspiring individuals in the fields of Electrician, COPA, Electronic Mechanics and Fitter trades. We aim to:</h5>
                <p className="card-text justifytext">Equip students with the knowledge, skills, and practical experience necessary to excel in their chosen professions.
                  Offer industry-aligned curriculum that meets the evolving needs of the industrial sector.
                  Provide hands-on training in modern facilities under the guidance of experienced faculty members.
                  Promote innovation, creativity, and problem-solving skills among our students.</p>

              </div>
            </div>
            <div className="col-md-6">
              <img src={about} className="card-img-top" alt="front office" />

            </div>
          </div>
        </div>

      </div>
     <ScrollToTop smooth top="100" color="maroon"/>
      <br />
      <hr />
      <div style={{ color: "white", padding: "14px;", margin: 10 }} className="fixed-bottom "> <a style={{ color: "white" }} href="tel: 9735090503" className="callus" > <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-phone" viewBox="0 0 16 16">
        <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z" />
        <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
      </svg> Call Us  </a></div>

      <div className="album py-3">
        <div className="container">
          <div className="row ">
            <div className="col-md-4">
              <div className='imagestyle'>
                <a href='iti'>
                <div className="card">
                  <img src={iticourse} className="card-img-top" alt="iticourse" />
                  <div className="card-body">
                    <h5 className="card-title">ITI</h5>
                    <p className="card-text"> (ELECTRONICS MECHANIC, ELECTRICIAN, FITTER, COPA)</p>
                    <a href="iti" className="courses">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></a>
                  </div>
                </div>
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className='imagestyle'>
                <a href='hotel-management'>
                <div className="card">
                  <img src={hotelmanagement} className="card-img-top" alt="hotelmanagement" />
                  <div className="card-body">
                    <h5 className="card-title">Hotel Management</h5>
                    <p className="card-text">Best Hotel Management Course at Maa Tara Foundation</p>
                    <a href="hotel-management" className="courses">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></a>
                  </div>
                </div>
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className='imagestyle'>
                <a href='Paramedical'>
                <div className="card">
                  <img src={paramedical} className="card-img-top" alt="iticoursparamedical" />
                  <div className="card-body">
                    <h5 className="card-title">Paramedical</h5>
                    <p className="card-text">Best Paramedical Course at Maa Tara Foundation</p>
                    <a href="Paramedical" className="courses">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></a>
                  </div>
                </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />

      <div className="containerse">
                <center>
                    <br />
                    <div className="album py-0">

                        <div className="container">
                            <br/>
                           

                            <h1><b>Maa Tara Foundation</b></h1>
                            <h6> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-geo-alt" viewBox="0 0 16 16">
                  <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                  <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                </svg> Chanak  (Near BUS Stop), Nabagram, Murshidabad, West Bengal, 742184</h6>
                      
                        </div>
                    </div>
                </center>
            </div>
      <div className='pincipalspeeh'>
      <br />
        <div className="album py-2">
          <div className="container">
            <div className="row">
              <div className="col-md-5 mt-3">
                <div className='backdirector'>
                  <div className="card mb-3" >
                    <div className="row g-0">
                      <div className="col-md-4">
                        {/* <img src="#" className="img-fluid rounded-start me-3" alt="principal_img" /> */}
                      </div>
                      <div className="col-md-8">
                        <div className="card-body">
                          <h5 className="card-title"><b>Principal’s Message</b></h5>
                          {/* <h6 className="card-text"><b>Name..........</b></h6> */}


                        </div>

                      </div>

                      <div className='justifynew'>
                        <p className="card-text mb-0"> Welcome to Maa Tara Foundation – a beacon of skill, service, and success.</p>
                        <p className="card-text justify mt-1 mb-1"> At Maa Tara Foundation,  It is about empowering individuals with the knowledge, skills, and confidence to shape their future. Our institution is built upon the values of dedication, discipline, and development, and we strive to ensure that every student who walks through our doors becomes a capable, responsible, and compassionate professional.</p>
                        <a href='principal-massage'>

                          <button className='massage'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
</svg></button>

                        </a>
                        <br />
                        <br />

                      </div>

                    </div>
                  </div>
                </div>
                {/* <DirectorImg /> */}
              </div>

              <div className="col-md-7 mt-3">
                <div className="card text-warning bg-white mb-2">
                <h4 className='btn-grad67 '><b className='blink'>NOTICE BOARD</b></h4>
<br/>
                  <Notice />
                  <br/>

                </div>
<br/>
                <div className="card border-dark text-center">
                  <div className="card-header " style={{ color: "maroon" }}>
                    <b>    LATEST NEWS</b>
                  </div>
                  <div className="card-body">
                   
                    <LatestNews/> 
                    <br/>
                  </div>

                </div>

              </div>

            </div>
          </div>
        </div>

        <br />
      </div>
      <br/>
      <div className="album py-0">
          <div className="container">
            <div className='gallerytext'>
            <h1><b>ITI Photo</b></h1>
          </div>
          </div>
        </div>
<Itiphoto/>
     <br/>
     <hr/>
      <div className="album py-0">
          <div className="container">
            <div className='gallerytext'>
            <h1><b>Paramedical Photo</b></h1>
          </div>
          </div>
        </div>
     <ParamedicalPhoto/>
      <div className='galleryback'>
        <br />
        <div className="album py-0">
          <div className="container">
            <div className='gallerytext'>
            <h1><b>Gallery</b></h1>
          </div>
          </div>
        </div>
        <Gallery />
        <br />
        <br />
      </div>



    </div>
  )
}

export default Home